import React, { Component } from 'react';
import { connect } from 'react-redux';
import BuyButton from '../Components/BuyButton';
import { receive, loadError } from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';
import { add as addToCartService } from '../Services/Cart.service';
import withReactiveStyleBuyButton from './withReactiveStyleBuyButton';

class BuyButtonContainer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <BuyButton
        {...this.props}
        onClick={(articleNumber, quantityFieldId, isBuyAndCollect) =>
          this.props.onClick({
            articleNumber,
            quantityFieldId,
            isBuyAndCollect,
          })
        }
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSuccess: (cart) => {
      dispatch(receive(cart));
    },
    onError: (ex) => {
      dispatch(catchError(ex, (error) => loadError(error)));
    },
  };
};

const onClick = ({ articleNumber, quantityFieldId, isBuyAndCollect }) => {
  localStorage.setItem('isBuyAndCollectButton', isBuyAndCollect ? '1' : '0');
  const quantityField = quantityFieldId
    ? document.getElementById(quantityFieldId)
    : undefined;
  const quantity = quantityField ? quantityField.value : 1;
  const addToCartServiceFunc = () =>
    addToCartService({
      articleNumber,
      quantity,
    });
  return addToCartServiceFunc();
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withReactiveStyleBuyButton(BuyButtonContainer, onClick, 'buy-button-container')
);
